export const environment = {
    production: false,
    siteUrl: 'https://pdfmarkup.sohodragon.nyc',
    apiBaseUrl: 'https://pdfeditorwebapp.azurewebsites.net/api/values/', //'http://localhost:43956/api/values/';
};